import type { TV, VariantProps } from "tailwind-variants";
import { tv as tvBase } from "tailwind-variants";

const twMergeConfig = {
  theme: {},
  classGroups: {},
};

export const tv: TV = (options, config) => {
  return tvBase(options, {
    ...config,
    twMerge: config?.twMerge ?? true,
    twMergeConfig: {
      ...config?.twMergeConfig,
      theme: {
        ...config?.twMergeConfig?.theme,
        ...twMergeConfig.theme,
      },
      classGroups: {
        ...config?.twMergeConfig?.classGroups,
        ...twMergeConfig.classGroups,
      },
    },
  });
};

export type { VariantProps };
